import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-NM9JDB8',
};

TagManager.initialize(tagManagerArgs);
